import { configureStore } from '@reduxjs/toolkit';
import rootReducer from '../root-reducer';


export const store = configureStore({
  reducer: rootReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      // Remove thunk middleware as it's included by default in RTK
    }),
  devTools: process.env.NODE_ENV !== 'production',
});

 

// Infer the `RootState` and `AppDispatch` types from the store itself
export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;

export default store;
